import * as constants from '../constants';

export const dashboardExportComplete = (id) => ({type: constants.DASHBOARD_EXPORT_COMPLETE, payload: {id}});
export const surveyExportComplete = (id) => ({type: constants.SURVEY_EXPORT_COMPLETE, payload: {id}});
